/*
Author : Arman Ali
Module: Department
github: https://github.com/Arman-Arzoo
*/
import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {ResponseApi} from "../BaseApi";

const departmentSectionSlice = createSlice({
    name: 'departmentSection',
    initialState: {
        getAllDepartments: {},
        createDepartment: {},
        updateDepartment: {},
        deleteDepartment: {},
        addDepartmentById: {},
        removeAlluserFromDepartment: {},
        getUsersDepartment: [],
        removeUserFromDepartment: {},
    },
    reducers: {},
    extraReducers: {
        'departmentSection/getAllDepartments/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllDepartments = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.info(t('something_went_wrong_2'));
            }
        },
        // Errors are reported by the component through errorMsg, so the response code keeps its own message
        'departmentSection/createDepartment/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createDepartment = data;
                toast.success(t('has_been_created_successfully'));
            }
        },

        'departmentSection/updateDepartment/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.updateDepartment = data;
                toast.success(t('has_been_updated_successfully'));
            }
        },
        'departmentSection/deleteDepartment/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_deleted_successfully'));
                state.deleteDepartment = data;
            } else if (status >= 400 && status < 500) {
                toast.info(t('something_went_wrong_2'));
            }
        },
        'departmentSection/addDepartmentById/fulfilled': (state, action) => {
            state.addDepartmentById = ResponseApi(action.payload);
        },
        'departmentSection/removeAlluserFromDepartment/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('has_been_deleted_successfully'));
                state.removeAlluserFromDepartment = data;
            } else if (status >= 400 && status < 500) {
                toast.info(t('something_went_wrong_2'));
            }
        },
        'departmentSection/getUsersDepartment/fulfilled': (state, action) => {
            state.getUsersDepartment = ResponseApi(action.payload);
        },
        'departmentSection/removeUserFromDepartment/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.removeUserFromDepartment = data?.data;
                toast.success(t('has_been_deleted_successfully'));
            } else if (status >= 400 && status < 500) {
                toast.info(t('something_went_wrong_2'));
            }
        },
    },
});

export const {} = departmentSectionSlice.actions;

export default departmentSectionSlice.reducer;
